function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-ralali-icon_svg__a",
  d: "M0 0h4.441v20.331H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "logo-ralali-icon_svg__c",
  d: "M0 0h19.999v20.331H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "logo-ralali-icon_svg__e",
  d: "M0 0h12.22v12.046H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "logo-ralali-icon_svg__g",
  d: "M0 0h12.22v12.047H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7.67)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "logo-ralali-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-ralali-icon_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5917",
  d: "M2.22 20.33C.995 20.33 0 19.353 0 18.143V2.188C0 .98.995 0 2.22 0c1.226 0 2.221.98 2.221 2.188v15.954c0 1.21-.995 2.189-2.221 2.189",
  mask: "url(#logo-ralali-icon_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7.67)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "logo-ralali-icon_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-ralali-icon_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5917",
  d: "M17.78 20.33c-1.228 0-2.22-.978-2.22-2.188v-.579c0-3.021-2.495-5.48-5.562-5.48C4.485 12.084 0 7.662 0 2.226v-.037C0 .98.994 0 2.22 0c1.225 0 2.22.98 2.22 2.188v.037c0 3.021 2.494 5.48 5.558 5.48C15.513 7.705 20 12.128 20 17.563v.58c0 1.209-.994 2.188-2.22 2.188",
  mask: "url(#logo-ralali-icon_svg__d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.78 .036)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "logo-ralali-icon_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-ralali-icon_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5917",
  d: "M10 12.046c-1.227 0-2.22-.979-2.22-2.188 0-3.023-2.495-5.48-5.56-5.48-1.227 0-2.22-.98-2.22-2.19C0 .98.993 0 2.22 0c5.514 0 10 4.422 10 9.858 0 1.209-.995 2.188-2.22 2.188",
  mask: "url(#logo-ralali-icon_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  d: "M10 19.752c-1.226 0-2.22-.98-2.22-2.19 0-1.208.994-2.188 2.22-2.188 3.065 0 5.56-2.459 5.56-5.48 0-1.21.993-2.19 2.22-2.19 1.226 0 2.22.98 2.22 2.19 0 5.436-4.487 9.858-10 9.858"
}), /*#__PURE__*/React.createElement("mask", {
  id: "logo-ralali-icon_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-ralali-icon_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  d: "M2.22 12.047c-1.225 0-2.22-.98-2.22-2.19C0 4.423 4.486 0 10 0c1.226 0 2.22.98 2.22 2.188 0 1.21-.994 2.19-2.22 2.19-3.065 0-5.559 2.457-5.559 5.48 0 1.21-.995 2.189-2.221 2.189",
  mask: "url(#logo-ralali-icon_svg__h)"
}));

function SvgLogoRalaliIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 30
  }, props), _ref, _ref2);
}

export default SvgLogoRalaliIcon;